import React from 'react';
import { components } from 'react-select';
import { useTranslation } from 'react-i18next';

import { LawMenuListPropTypes } from 'src/components/JobChecklistForm/propTypes';
import Checkbox from 'src/components/Checkbox';
import s from './JobChecklistForm.styles';

const LawMenuListComponent = ({ children, isFiltered, setIsFiltered, ...rest }) => {
  const { t } = useTranslation();

  return (
    <components.MenuList {...rest}>
      <s.LawMenuListFilter
        onClick={e => {
          e.preventDefault();

          setIsFiltered(!isFiltered);
        }}
      >
        <Checkbox
          checked={isFiltered}
          label={t('FORM_FILTER_BY_NON_COMPLIANCE')}
        />
      </s.LawMenuListFilter>
      {children}
    </components.MenuList>
  );
};

LawMenuListComponent.propTypes = LawMenuListPropTypes;

export const LawMenuList = React.memo(LawMenuListComponent);
